export const MAX_MOBILE_LIST_HEIGHT = 50; // vh
